import { render, staticRenderFns } from "./EmpresaLista.vue?vue&type=template&id=e3e654fa"
import script from "./EmpresaLista.vue?vue&type=script&lang=js"
export * from "./EmpresaLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports